/**
 * Questions the natural-language box can answer from the data Pear holds.
 * Each one maps cleanly onto catalog fields, so they double as a tour of
 * what analytics can do.
 */
export const SUGGESTED_QUERIES: Array<{ text: string }> = [
  { text: 'How many patients have consented to APCM?' },
  { text: 'Consented patients by primary care provider' },
  { text: 'Diabetic patients we have not reached in the last 30 days' },
  { text: 'Patients with open care gaps and no completed check-in' },
  { text: 'Spanish-speaking patients over 65 without an approved care plan' },
  { text: 'Completed calls per week over the last 2 months' },
  { text: 'Patients with an urgent open action item' },
  { text: 'Patients with 3 or more chronic conditions who never picked up' },
];
